export default __webpack_public_path__ + "static/media/orange.53c3c9ef.png";